import g from "../../node_modules/classnames/index.js";
import { forwardRef as h } from "react";
import w from "../../node_modules/react-select/dist/react-select.esm.js";
import "./UIInputSelect2.js";
import { jsx as n } from "../../_virtual/jsx-runtime.js";
import { c as I } from "../../node_modules/react-select/dist/index-a86253bb.esm.js";
function x(t) {
  return /* @__PURE__ */ n(I.DropdownIndicator, {
    ...t,
    children: /* @__PURE__ */ n("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      children: /* @__PURE__ */ n("path", {
        fillRule: "evenodd",
        d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      })
    })
  });
}
function D(t) {
  return {
    ...t,
    spacing: {
      ...t.spacing,
      menuGutter: -6
    }
  };
}
function N({
  hasError: t,
  options: r,
  isSearchable: i,
  name: s,
  className: c,
  disabled: u,
  onBlur: l,
  onChange: m,
  placeholder: p,
  value: a,
  variant: o = "medium"
}, d) {
  const f = r.find((e) => e.value === a);
  return /* @__PURE__ */ n(w, {
    className: g("input-select", c, {
      "input-select--medium": o === "medium",
      "input-select--large": o === "large",
      "input-select--error": t
    }),
    isSearchable: i,
    noOptionsMessage: () => "Aucun r\xE9sultat",
    classNamePrefix: "input-select",
    theme: (e) => D(e),
    components: {
      DropdownIndicator: x
    },
    isDisabled: u,
    placeholder: p,
    name: s,
    ref: d,
    value: f,
    onChange: (e) => m(e == null ? void 0 : e.value, !0),
    onBlur: l,
    options: r
  });
}
const U = h(N);
export {
  U as UIInputSelect
};
//# sourceMappingURL=UIInputSelect.js.map
